namespace GeniuzPOS.ReportMasterData {
    export interface Report_1312Row {
        Id?: string;
        DocDate?: string;
        ShopId?: string;
        ShopName?: string;
        SubCat1Code?: string;
        SubCat1Name?: string;
        FullName?: string;
        FullName2?: string;
        Qty?: number;
        GrossSales?: number;
        AllItemDiscount?: number;
        NetSales?: number;
        NetSalesExVat?: number;
        VatOfNetSales?: number;
    }

    export namespace Report_1312Row {
        export const idProperty = 'Id';
        export const nameProperty = 'Id';
        export const localTextPrefix = 'ReportMasterData.Report_1312';
        export const deletePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const insertPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const readPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const updatePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';

        export declare const enum Fields {
            Id = "Id",
            DocDate = "DocDate",
            ShopId = "ShopId",
            ShopName = "ShopName",
            SubCat1Code = "SubCat1Code",
            SubCat1Name = "SubCat1Name",
            FullName = "FullName",
            FullName2 = "FullName2",
            Qty = "Qty",
            GrossSales = "GrossSales",
            AllItemDiscount = "AllItemDiscount",
            NetSales = "NetSales",
            NetSalesExVat = "NetSalesExVat",
            VatOfNetSales = "VatOfNetSales"
        }
    }
}
